<script setup lang="ts">
  import { MpText } from '@borg/ui';
  import { ArticleGroup } from '../types';

  defineProps<{
    data: ArticleGroup;
  }>();

  const projectConfig = useProjectConfig();
</script>

<template>
  <div class="article-block">
    <MpText
      class="article-block__title"
      as="h1"
      bold
    >
      {{ data.title }}
    </MpText>
    <div class="article-block__wrapper">
      <ArticlePreview
        :article="data.main"
        large
      />
      <div>
        <ArticleList
          :articles="data.additional"
          :category="data.title"
          :display-show-more-button="projectConfig.features.articlesShowMore"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .article-block {
    width: 100%;

    &:first-of-type {
      padding-top: 0;
    }

    &:last-of-type {
      border: none;
    }

    &__title {
      @include screen-md {
        margin-bottom: var(--mp-space-70);
      }
    }

    &__wrapper {
      display: flex;
      flex-direction: column;
      gap: var(--mp-space-70);

      @include screen-md {
        flex-direction: row;
      }

      &__side {
        @include screen-md {
          width: 27rem;
        }
      }
    }
  }
</style>
